import { createFileRoute } from "@tanstack/react-router";
import type { FoodTasterId } from "@brewbase/db/types";
import { TasterPage } from "@/features/food-sensory/tasters/taster-page";

export const Route = createFileRoute("/food-app/tasters/$taster_id")({
  component: function TasterRoute() {
    const { taster_id } = Route.useParams();
    return <TasterPage key={taster_id} tasterId={taster_id as FoodTasterId} />;
  },
  parseParams: (params) => ({
    taster_id: parseInt(params.taster_id, 10),
  }),
});
